export const confirmationConfig: any = {
  heading: 'Confirm Your Details',
  theme: 'dark',
  sections: [],
  unitsData: {},
  individualUnitsData: {},
  facilityId: '',
  ledgerId: '',
};
export const StepMaxCount = {
  ReservationPage: 1,
  MoveInPage: 3,
};

export const paymentUrl = 'payment';
export const errorUrl = 'error';
export const thankYouPageUrl = 'thank-you';
export const ErrorMessageInfo = {
  errorMessagePara: 'Please check if the details entered are correct.',
  errorMessageHeading: 'We Have A Little Problem',
  errorMessageTimeOut: 10000,
};
export const unitDetailHeading = 'Unit Details';
